export default {
  Title: "湖北工业大学工程技术学院",
  LoginReturn: "http://gcxywx.hbut.edu.cn/CodeLogin",
  AppId: "ww6ddbbe4c169a43e5",
  LoginAppId: "1000009",
  LoginToken: "LoginToken",
  LoginRole: "LoginRole",
  CodeState: "AE12AB07-FB5A-4A20-86B6-B7952384C87C",
  LoginInfo: "LoginInfo",
  signalRPath: "chatHub"
}